import { call, takeLatest, all, put } from "redux-saga/effects";
import { storeItemNameResult } from "./actions";
import { getHeaderJWT, URL } from "../../../store/path";
import { handlError, parseError } from "../../app/serverError";
import axios from "axios";

function* watchItemNameSearch() {
  yield takeLatest("SEARCH_ITEM_NAME", initiateSearch);
}

function* initiateSearch(action) {
  let { response, error } = yield call(searchAPI, action.payload, action.cid);
  if (response) {
    try {
      let getDate = getDateAfterArrange(response.data.data);
      yield put(storeItemNameResult(getDate, action.name));
    } catch (error) {
      sagaErrorMessage(error, action);
    }
  } else {
    yield put(handlError(action, parseError(error)));
    sagaErrorMessage(error, action);
  }
}

function getDateAfterArrange(data) {
  if (!Array.isArray(data)) {
    console.error("Invalid data format: Expected an array", data);
    return [];
  }

  return data.map((item) => ({
    ...item, // Keep existing properties
    key: item.item_name,
    value: item.item_name,
    text: item.item_name,
    title: item.item_name,
  }));
}

async function searchAPI(data, cid) {
  let head = getHeaderJWT();
  try {
    let apiUrl = `${URL}/master/rlb/itemName`;
    if (cid) apiUrl += `/${cid}`;
    const response = await axios.post(
      apiUrl,
      data,
      head
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

//#endregion

const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type);
  console.log(error);
  console.groupEnd();
};

export default function* itemNameSearchSaga() {
  yield all([watchItemNameSearch()]);
}
